var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentWarning1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0024 9.99913V7.82623C18.0024 7.29601 17.7913 6.78679 17.4162 6.41164L14.587 3.58246C14.2118 3.2073 13.7026 2.99622 13.1724 2.99622H5.99742C4.89195 2.99622 3.99658 3.89159 3.99658 4.99705V19.0029C3.99658 20.1083 4.89195 21.0037 5.99742 21.0037H9.99908",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0026 7.9983H14.0009C13.4487 7.9983 13.0005 7.55011 13.0005 6.99788V2.99622",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5019 22.0041C14.0158 22.0041 12 19.9883 12 17.5022C12 15.0162 14.0158 13.0004 16.5019 13.0004C18.9889 13.0004 21.0037 15.0162 21.0037 17.5022C21.0037 19.9883 18.9889 22.0041 16.5019 22.0041",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5026 17.3352V15.6835",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5017 19.1579C16.4567 19.1579 16.4196 19.1949 16.4206 19.24C16.4206 19.285 16.4577 19.322 16.5027 19.322C16.5477 19.322 16.5837 19.285 16.5837 19.24C16.5837 19.1949 16.5477 19.1579 16.5017 19.1579",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentWarning1);
export default __webpack_public_path__ + "static/media/document-warning-1.0db735f45c2c98c55f78d591961d2919.svg";
export { ForwardRef as ReactComponent };